<template>
    <PublicPageLayout heading="§public.request_password_reset_heading">
        <CoreStringInput
            v-model="email"
            :validator="v$.email"
            :fullWidth="true"
            placeholder="§ui.placeholder_login_email"
            class="mb-10"
        />

        <div class="flex justify-start">
            <CoreButton
                @click="handleSubmit"
                label="§ui_button.request_password_reset"
                icon="pi-arrow-up-right"
                :loading="waiting"
                :disabled="!isValid"
            />
        </div>
    </PublicPageLayout>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, maxLength, email as emailRule } from '@vuelidate/validators'
import { useAuthStore } from '@/stores/auth'
import PublicPageLayout from './components/PublicPageLayout.vue'
import CoreButton from '@/components/core/CoreButton.vue'
import CoreStringInput from '@/components/core/CoreStringInput.vue'

export default {
    name: 'ResetPasswordRequest',

    components: {
        PublicPageLayout,
        CoreButton,
        CoreStringInput,
    },

    data() {
        return {
            email: '',
            waiting: false,
            v$: {},
            rules: {
                email: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(100),
                    email: emailRule,
                },
            },
        }
    },

    created() {
        this.authStore = useAuthStore()
    },

    computed: {
        isValid() {
            return this.v$ ? !this.v$.$invalid : false
        },
    },

    mounted() {
        this.v$ = useVuelidate(this.rules, this)
    },

    watch: {
        email(value) {
            this.v$.$touch()
        },
    },

    methods: {
        async handleSubmit() {
            this.v$.$touch()
            if (this.waiting || this.v$.$invalid) return

            this.waiting = true
            try {
                await this.authStore.requestPasswordReset(this.email)
                this.waiting = false
                this.$toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: '§ui_message.reset_password_request_sent',
                    life: 1000,
                })
                setTimeout(() => {
                    this.$router.push({ path: '/' })
                }, 3000)
            } catch (error) {
                this.waiting = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'An unexpected error occurred',
                    life: 2000,
                })
            }
        },
    },
}
</script>
